export const arrayPr = []

export const objPr = {}